import { Button, Stack } from '@mui/material';
import axios from '../../../util/Axios';
import { FaceResult } from './FaceResult';
import { SpeechResult } from './SpeechResult';
import { ArmsResult } from './ArmsResult';
import { useState } from 'react';

export function EvaluationResults({ testId, model1Result }) {
  const [result, setResult] = useState(model1Result);

  const onCalculate = () => {
    axios('/strokeTests/' + testId + '/evaluation', { method: 'POST' }).then((resp) => {
      setResult(resp.data);
    });
  };

  return (
    <>
      <Stack spacing={2}>
        <Button sx={{ width: 200 }} variant="contained" onClick={() => onCalculate(true)}>
          Calculate
        </Button>
        { result ?
          <>
            <FaceResult model1Result={result} title="FAST AI Score" />
            <SpeechResult model1Result={result} />
            <ArmsResult model1Result={result} vertical={true} />
          </>
          :
          null
        }
      </Stack>
    </>
  );
}
